<template>
  <BreadCrumb PageTitle="Détails d'un emploi" />
  <ViewEmploi />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ViewEmploi from "@/components/EmploiDuTemps/ViewEmploi.vue";

  export default defineComponent({
    name: "ViewEmploiPage",
    components: {
      BreadCrumb,
      ViewEmploi,
    },
  });
</script>